module.exports = __webpack_public_path__ + "static/media/clue-3.0a962538.svg";